import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import businessReducer from './slices/businessSlice';
import productReducer from './slices/productSlice';
import catalogReducer from './slices/catalogSlice';
import dashboardReducer from './slices/dashboardSlice';
import enquiryReducer from './slices/enquirySlice';
import analyticsReducer from './slices/analyticsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    business: businessReducer,
    product: productReducer,
    catalog: catalogReducer,
    dashboard: dashboardReducer,
    enquiry: enquiryReducer,
    analytics: analyticsReducer,
  },
});


export default store;
